export const WALLET_CHOICE_KEY = 'wagmi.wallet';
